<template>
<!-- 客户询价单 -->
  <section>
    <!-- 搜索/查询 -->
    <el-col :span="24" class="order_toolbar toolbar pad_left">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <div class="goodslist1">
            <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </div>
          <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
        </div>
        <el-collapse-transition>
          <div style="padding:0 20px 20px 20px" v-show="show3">
            <!-- 上 -->
            <el-form :inline="true" :model="filters" style="margin-top:10px;display:flex;" class="findform">
              <!-- 顶部搜索框 -->
              <el-form-item style="width:100%;display:flex" label="询 价 单 号：">
                <el-input placeholder="请输入询价单号" v-model="filters.orderNo" maxlength="20"/>
              </el-form-item>
              <el-form-item style="width:100%;display:flex" label="询 价 城 市：">
                <el-cascader placeholder="请选择城市" style="background:#fff;width:100%" v-model="filters.chengshi"
                  :options="options" filterable clearable @change="handleChange"/>
              </el-form-item>
              <el-form-item style="width:100%;display:flex" label="询 价 状 态：">
                <el-select v-model="filters.biddingStatusId" placeholder="请选择" filterable>
                  <el-option v-for="(item,index) in biddingStatusarr" :key="index" :label="item.Name" :value="item.Id"/>
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 中 -->
            <el-form :inline="true" :model="filters" style="margin-top:10px;display:flex;" class="findform">
              <el-form-item style="width:100%;display:flex" label="询 价 品 类：">
                <el-select v-model="filters.brandTypeIds" placeholder="请选择" filterable>
                  <el-option v-for="(item,index) in pinleiptions" :key="index" :label="item.Name" :value="item.Id"/>
                </el-select>
              </el-form-item>
              <el-form-item style="width:100%;display:flex;" label="意 向 品 牌：">
                <el-select v-model="filters.brandIds" placeholder="请选择" filterable>
                  <el-option v-for="(item,index) in pinpaiptions" :key="index" :label="item.Name" :value="item.Id"/>
                </el-select>
              </el-form-item>
              <el-form-item style="width:100%;display:flex" label="预　　　算：">
                <div style="width:100%;display:flex;justify-content:space-between;">
                  <el-input placeholder="请输入预算范围" v-model="filters.minPurchasingPrice" maxlength="9"
                  type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
                  <label style="margin: 0 5px">至</label>
                  <el-input placeholder="请输入预算范围" v-model="filters.maxPurchasingPrice" maxlength="9"
                  type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
                </div>
              </el-form-item>
            </el-form>
            <!-- 下 -->
            <el-form :inline="true" :model="filters" style="margin-top:10px;display:flex;" class="findform">
              <el-form-item style="width:66%;display:flex" label="风　　　格：">
                <el-select v-model="filters.styleId" placeholder="请选择风格" filterable>
                  <el-option v-for="(item,index) in stylearr" :key="index" :label="item.Name" :value="item.Id"/>
                </el-select>
              </el-form-item>
              <el-form-item style="width:100%;display:flex" label="户　　　型：">
                <div style="width:100%;display:flex">
                  <el-select v-model="filters.roomId" placeholder="室" style="width: 25%">
                    <el-option v-for="(item,index) in roomArr" :key="index" :label="item.Name" :value="item.Id"/>
                  </el-select>
                  <el-select v-model="filters.officeId" placeholder="厅" style="width: 25%">
                    <el-option v-for="(item,index) in officeArr" :key="index" :label="item.Name" :value="item.Id"/>
                  </el-select>
                  <el-select v-model="filters.kitchenId" placeholder="厨" style="width: 25%">
                    <el-option v-for="(item,index) in kitchenArr" :key="index" :label="item.Name" :value="item.Id"/>
                  </el-select>
                  <el-select v-model="filters.toiletId" placeholder="卫" style="width: 25%">
                    <el-option v-for="(item,index) in toiletArr" :key="index" :label="item.Name" :value="item.Id"/>
                  </el-select>
                </div>
              </el-form-item>
              
              <el-form-item style="width:32.5%;text-align: right;">
                <el-button type="danger" @click="onSubmit">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
    </el-col>

    <!--列表-->
    <template>
      <el-col :span="24" class="order_content main_container">
        <section class="model_section">
          <el-col :span="18" style>
            <p class="model_top_title">客户询价单</p>
          </el-col>
        </section>
        <!-- table 列表 -->
        <div class="table_container">
          <div class="table_inner_container" style="height:auto">
            <el-table :data="dataList" stripe border style="height:auto;max-height:500px">
              <el-table-column label="询价单号" align="center">
                <template scope="scope">
                  <span :title="scope.row.OrderNo" :label="scope.row.OrderNo">{{scope.row.OrderNo}}</span>
                </template>
              </el-table-column>
              <el-table-column label="所在城区" align="center">
                <template scope="scope">
                  <span :title="scope.row.Address" :label="scope.row.Address">{{scope.row.Address}}</span>
                </template>
              </el-table-column>
              <el-table-column label="房屋面积" align="center">
                <template scope="scope">
                  <span :title="scope.row.BuildingArea" :label="scope.row.BuildingArea">{{scope.row.BuildingArea}}</span>
                </template>
              </el-table-column>
              <el-table-column label="户型" align="center">
                <template scope="scope">
                  <span :title="scope.row.HouseType" :label="scope.row.HouseType">{{scope.row.HouseType}}</span>
                </template>
              </el-table-column>
              <el-table-column label="询价品类" align="center">
                <template scope="scope">
                  <span :title="scope.row.BrandType" :label="scope.row.BrandType">{{scope.row.BrandType}}</span>
                </template>
              </el-table-column>
              <el-table-column label="预算" align="center">
                <template scope="scope">
                  <span :title="scope.row.Budget" :label="scope.row.Budget">{{scope.row.Budget}}</span>
                </template>
              </el-table-column>
              <el-table-column label="询价状态" align="center">
                <template scope="scope">
                  <span :title="scope.row.StatusName" :label="scope.row.StatusName">{{scope.row.StatusName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="报价次数" align="center">
                <template scope="scope">
                  <span :title="scope.row.QuoteCount" :label="scope.row.QuoteCount">{{scope.row.QuoteCount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center">
                <template scope="scope">
                  <span @click="seeOrder(scope.row.Id)" class="handle">
                    <i class="el-icon-view"></i>查看
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
            :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
        </div>
      </el-col>
    </template>

    <!-- 抽屉详情 size="60%" -->
    <InquiryDetails ref="refInquiryDetails"/>

  </section>
</template>
<script>
import { getSelectInquiryByCondition, getkind, getProvinceAndCityAndZoneByDataType } from "../../api/api";
import InquiryDetails from './InquiryDetails';

export default {
  name: 'LowPriceManagement',
  data() {
    return {
      show3: false,
      timer: null,
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      // 所属城市
      provinceId: 0,
      cityId: 0,
      zoneId: 0,
      options: [],
      // 询价状态
      biddingStatusarr: [ {Id: 0, Name: '请选择'},
        {Id: 1,Name: '报价中'}, {Id: 2,Name: '竞标中'}, {Id: 7,Name: '未中标'},{Id: 3,Name: '客户待支付'},
        {Id: 4,Name: '客户已支付'}, {Id: 5,Name: '询价完成'}, {Id: 6,Name: '询价失败'}
      ],
      // 室
      roomArr: [ {Id: 0, Name: '请选择'},
        {Id: 1,Name: '一室'}, {Id: 2,Name: '二室'}, {Id: 3,Name: '三室'}, {Id: 4,Name: '四室'},
        {Id: 5,Name: '五室'}, {Id: 6,Name: '六室'}, {Id: 7,Name: '七室'}, {Id: 8,Name: '八室'}
      ],
      // 厅
      officeArr: [ {Id: -1,Name: '请选择'}, {Id: 0,Name: '0 厅'},
        {Id: 1,Name: '一厅'}, {Id: 2,Name: '二厅'}, {Id: 3,Name: '三厅'}, {Id: 4,Name: '四厅'},
        {Id: 5,Name: '五厅'}, {Id: 6,Name: '六厅'}, {Id: 7,Name: '七厅'}, {Id: 8,Name: '八厅'}
      ],
      // 厨
      kitchenArr: [ {Id: -1,Name: '请选择'}, {Id: 0,Name: '0 厨'},
        {Id: 1,Name: '一厨'}, {Id: 2,Name: '二厨'}, {Id: 3,Name: '三厨'}, {Id: 4,Name: '四厨'},
        {Id: 5,Name: '五厨'}, {Id: 6,Name: '六厨'}, {Id: 7,Name: '七厨'}, {Id: 8,Name: '八厨'}
      ],
      // 卫
      toiletArr: [ {Id: -1,Name: '请选择'}, {Id: 0,Name: '0 卫'},
        {Id: 1,Name: '一卫'}, {Id: 2,Name: '二卫'}, {Id: 3,Name: '三卫'}, {Id: 4,Name: '四卫'},
        {Id: 5,Name: '五卫'}, {Id: 6,Name: '六卫'}, {Id: 7,Name: '七卫'}, {Id: 8,Name: '八卫'}
      ],
      stylearr: [], // 询价风格
      pinleiptions: [], // 询价品类
      pinpaiptions: [], // 意向品牌
      filters: {
        orderNo: "", // 询价单号
        chengshi: "", // 询价城市
        biddingStatusId: 0, // 状态ID
        roomId: 0, // 室
        officeId: -1, // 厅
        kitchenId: -1, // 厨
        toiletId: -1, // 卫
        styleId: 0, // 风格
        minPurchasingPrice: '', // 最低预算
        maxPurchasingPrice: '', // 最高预算
        brandTypeIds: 0, // 询价品类
        brandIds: 0 // 意向品牌
      },
      queryId: ''
    }
  },
  components: {
    InquiryDetails
  },
  methods: {
    //查询列表
    getorder() {
      let addParams = {
        UserId: localStorage.Id, // 当前操作人id
        OrderNo: this.filters.orderNo, // 询价单号
        ProvinceId: this.provinceId, // 省ID
        CityId: this.cityId, // 市ID
        ZoneId: this.zoneId, // 区ID
        OrderStatus: this.filters.biddingStatusId, // 订单状态ID
        RoomNumber: this.filters.roomId,
        HallNumber: this.filters.officeId,
        KitchenNumber: this.filters.kitchenId,
        ToiletNumber: this.filters.toiletId,
        StyleId: this.filters.styleId,
        MinPrice: this.filters.minPurchasingPrice ? this.filters.minPurchasingPrice : 0, // 最小预算
        MaxPrice: this.filters.maxPurchasingPrice ? this.filters.maxPurchasingPrice : 0, // 最大预算
        BrandTypeId: this.filters.brandTypeIds, // 品类ID
        BrandId: this.filters.brandIds, // 品牌ID
        ConsumptionUserId: this.queryId, // ConsumptionUserId
        PageIndex: this.pageIndex, // 分页数据 当前页码
        PageSize: 10, // 分页数据 每页显示条数
      };
      getSelectInquiryByCondition(addParams).then(data => {
        this.dataList = data.ResultObj;
        this.total = data.RowsCount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },
    // 查看
    seeOrder(id) {
      this.$nextTick(() => {
        this.$refs.refInquiryDetails.init(id);
      })
    },
    //产品风格
    getstyle() {
      let that = this;
      var loginParams = {
        tableName: "tBD柜_风格",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.stylearr = data;
      })
    },
    // 询价分类
    getpinlei() {
      let that = this;
      var loginParams = {
        tableName: " tBDGoodsBrandType",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.pinleiptions = data;
      })
    },
    // 意向品牌
    getpinpai() {
      let that = this;
      var loginParams = {
        tableName: "tbdbrand",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.pinpaiptions = data;
      })
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      this.zoneId = val[2];
    },
    // 查找省+市+区
    getprovince() {
      var loginParams = {
        isOpen: 1,
        dataLevel: 3
      };
      getProvinceAndCityAndZoneByDataType(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.ResultObj.map(item => {
          // 所有省 查当前省下级市
          let provinceData = {value:item.Id,label:item.Name,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 所有市
          item.CityList.map(city => {
            let cityData = {value:city.Id, label:city.Name,children:[]};
            provinceData.children.push(cityData);
            // 区
            city.ZoneList.map(zone => {
              cityData.children.push({value:zone.Id, label:zone.Name});
            })
          })
        });
        that.options = provinceAndCityAndarea;
      })
    },
    // 重置
    fnReset() {
      this.filters = {
        orderNo: "", // 询价单号
        chengshi: "", // 询价城市
        biddingStatusId: 0, // 状态ID
        roomId: 0, // 室
        officeId: -1, // 厅
        kitchenId: -1, // 厨
        toiletId: -1, // 卫
        styleId: 0, // 风格
        minPurchasingPrice: '', // 最低预算
        maxPurchasingPrice: '', // 最高预算
        brandTypeIds: 0, // 询价品类
        brandIds: 0 // 意向品牌
      }
      this.provinceId = 0;
      this.cityId = 0;
      this.zoneId = 0;
      this.queryId = '';
      // this.pageIndex = 1;
      // this.getorder();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      if(Number(this.filters.minPurchasingPrice) && Number(this.filters.maxPurchasingPrice)) {
        // 如果预算最低值大于了 最高值
        if (Number(this.filters.minPurchasingPrice) > Number(this.filters.maxPurchasingPrice)) {
          this.$swal({
            type: "warning",
            text: "询价预算最低值不得大于最高值 !!!"
          });
          return
        }
      }
      this.getorder();
    },
    refresh() {
      this.getorder();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getorder();
    }
  },
  created() {
    let that = this;
    // 获取省市区
    this.getprovince();
    // 查询风格
    this.getstyle();
    // 查询询价品类
    this.getpinlei();
    // 意向品牌
    this.getpinpai();
    // 查询列表
    setTimeout(function() {
      that.getorder();
    }, 200);
    this.queryId = this.$route.query.ConsumptionUserId;
  }
}
</script>
<style>
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
</style>
<style scoped>
.el-form-item {
  margin-top: 10px;
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// LowPriceManagement.vue?121706f2